import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { Sidebar } from "./Sidebar.js";

const SIDEBAR_W = 240;

export function DashboardLayout() {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar width={SIDEBAR_W} />
      <Box component="main" sx={{ flex: 1, ml: `${SIDEBAR_W}px`, p: 3, minHeight: "100vh" }}>
        <Outlet />
      </Box>
    </Box>
  );
}
